/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 6/11/14
 * Time: 1:16 PM
**/

define(function (require) {
    "use strict";

    var CategoryModel = require("manager-models/CategoryModel");
    var OrderedCollection = require("collections/OrderedCollection");
    var ApiResources = require("assets/data/apiResources.json");
    var Config = require("manager-assets/config/config.json");

    var CategoriesCollection = OrderedCollection.extend({
        model: CategoryModel,
        resource: ApiResources.AccountConfig.Categories,
        name: "CategoriesCollection",

        initialize: function(models,options){
            options = options  || {} ;
            options.urlOption = options.urlOption || OrderedCollection.URL_OPTIONS.WITH_YOGA;

            OrderedCollection.prototype.initialize.call(this,models,options);
        },

        getMaxSize: function() {
            return Config.validators.categories.maxCategoriesPerAccount;
        }

    });

    CategoriesCollection.Model = CategoryModel; // is used by the data manager controller that managing this collection

    return CategoriesCollection;
});
